import { accessScaleOnly, type WidaStudent } from './widaHistory';

const STORAGE_KEY = 'bamboo.widaRoster.v1';

function storage(): Storage | null {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch {
    return null;
  }
}

export function saveWidaRoster(students: WidaStudent[]): void {
  const store = storage();
  if (!store) return;
  try {
    store.setItem(STORAGE_KEY, JSON.stringify(students));
  } catch {
    return;
  }
}

export function loadWidaRoster(): WidaStudent[] {
  const store = storage();
  if (!store) return [];
  try {
    const raw = store.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as WidaStudent[]) : [];
  } catch {
    return [];
  }
}

export function loadAccessRoster(): WidaStudent[] {
  return accessScaleOnly(loadWidaRoster());
}

export function loadPlanRoster(): WidaStudent[] {
  return loadWidaRoster();
}

export function findInRoster(roster: WidaStudent[], id: string): WidaStudent | null {
  const target = id.trim();
  if (target === '') return null;
  for (const student of roster) {
    if (
      student.id === target ||
      student.stateStudentId === target ||
      student.localStudentId === target
    ) {
      return student;
    }
  }
  return null;
}

export function findWidaStudent(id: string): WidaStudent | null {
  return findInRoster(loadAccessRoster(), id);
}

export function findPlanStudent(id: string): WidaStudent | null {
  return findInRoster(loadPlanRoster(), id);
}
